import React from "react";

function SearchSidebarSuggestions({
  showSuggestions,
  suggestions,
  suggestionsListRef,
  hoveredIndex,
  onHoveredIndexChange,
  onSelectSuggestion,
  getHighlightedLabel,
  listboxId,
}) {
  if (!showSuggestions || suggestions.length === 0) {
    return null;
  }

  return (
    <ul id={listboxId} className="ui-autocomplete ui-menu search-suggestions-dropdown" role="listbox" ref={suggestionsListRef}>
      {suggestions.map((suggestion, index) => {
        const prevType = index > 0 ? suggestions[index - 1].type : null;
        const nextType = index < suggestions.length - 1 ? suggestions[index + 1].type : null;
        const showSuggestedHeader = suggestion.type === "suggested" && prevType !== "suggested";
        const isLastSuggestedItem = suggestion.type === "suggested" && nextType !== "suggested";
        const optionId = listboxId ? `${listboxId}-option-${index}` : undefined;

        return (
          <React.Fragment key={`${suggestion.label}-${index}`}>
            {showSuggestedHeader && (
              <li className="ui-autocomplete-category label" aria-hidden="true">Suggested Search</li>
            )}
            <li
              id={optionId}
              className={`ui-menu-item${suggestion.type === "suggested" ? " suggested-search-item" : " category-item"}${isLastSuggestedItem ? " last-suggested-item" : ""}${hoveredIndex === index ? " ui-state-focus" : ""}`}
              role="option"
              aria-selected={hoveredIndex === index}
              tabIndex={-1}
              onClick={() => onSelectSuggestion(suggestion)}
              onMouseEnter={() => onHoveredIndexChange(index)}
              onMouseLeave={() => onHoveredIndexChange(null)}
            >
              <div
                className="ui-menu-item-wrapper"
                dangerouslySetInnerHTML={{ __html: getHighlightedLabel(suggestion.label) }}
              />
            </li>
          </React.Fragment>
        );
      })}
    </ul>
  );
}

export default SearchSidebarSuggestions;
